<template lang="pug">
	.budget-selection
		table.budget-table(cellspacing="0")
			thead
				tr.header-row
					td
					template(v-for="(budget, idx) in budgets")
						td.budget-td
							.flex-row.budget-name
								DxTextBox(v-if="editingBudgetIndex === idx", :value="budget.name", @value-changed="v => { budget.name = v.value; editingBudgetIndex = null; }")
								template(v-else)
									.name {{budget.name}}
									.actions.flex-row.flex-justify
										.budget-actions.horizontal-spacing.no-wrap
											DxButton(icon="edit", @click="editingBudgetIndex = idx")
											DxButton(v-if="budgets.length > 1", icon="trash", @click="budgets.splice(idx, 1)")
										.sub-actions(v-if="idx === budgets.length - 1")
											DxButton(icon="plus", @click="() => addNewBudget()")
			tbody
				tr.details
					td {{$tCaption('Term')}}
					template(v-for="budget in budgets")
						td.budget-td
							.flex-row.space
								DxNumberBox.center-aligned-number-box(:value="budget.term", @value-changed="(v) => budget.term = v.value", format="#0", :width="40")
								DxSelectBox(:items="periodTypes", :search-enabled="true", :value.sync="budget.period", value-expr="id", display-expr="name")
				template(v-for="product in data.products.map(f => getProduct(f))")
					tr.total-row.clickable(@click="toggleExpandedItem(product.id)")
						td
							.product.horizontal-spacing
								.expander(:class="{ expanded: expandedItems.indexOf(product.id) > -1 }")
									i.fas.fa-chevron-right
								.icon
									i(:class="[product.icon]")
								.name {{product.name}}
						template(v-for="budget in budgets.map((f, i) => getProductBudget(i, product.oid)).filter(f => f)")
							td.budget-td
								.budget-total
									.value {{formatNumber(budget.recurrentBudget)}}
									.description(v-if="product.recurrent != false") {{getReccurencyPeriod(budget)}}
					tr.details(v-if="product.highlight", :class="{invisible: isInvisible(product.id)}")
						td
						template(v-for="budget in budgets.map((f, i) => getProductBudget(i, product.oid)).filter(f => f)")
							td.budget-td
								.highlight {{product.highlight}}
					tr.details(v-if="product.id === 'sem'", :class="{invisible: isInvisible(product.id)}")
						template(v-for="budget in budgets.map((f, i) => getProductBudget(i, product.oid)).filter(f => f)")
							td {{$tCaption('Clicks per')}} {{budget.period}}
							td.budget-td
								.flex-row
									.data-value 180-220
					tr.details(v-if="product.components.indexOf('budget') > -1", :class="{invisible: isInvisible(product.id)}")
						td {{$tCaption('Budget')}}
						template(v-for="budget in budgets.map((f, i) => ({ prodBudget: getProductBudget(i, product.oid), period: f.period })).filter(f => f.prodBudget)")
							td.budget-td
								DxNumberBox(:value="budget.prodBudget.recurrentBudget", @value-changed="(v) => budget.prodBudget.recurrentBudget = v.value", :format="getCurrencyFormat(budget)")
					tr.details(v-if="product.components.indexOf('display') > -1", :class="{invisible: isInvisible(product.id)}")
						td {{$tCaption('Display component')}}
						template(v-for="budget in budgets.map((f, i) => getProductBudget(i, product.oid)).filter(f => f)")
							td.budget-td
								.flex-row
									.flex-col
										span {{$tCaption('CPM')}}
										DxNumberBox.number-edit(:value="budget.display.cpm", @value-changed="(v) => budget.display.cpm = v.value", :format="currencyFormat")
									.flex-col
										.flex-row
											.data-value {{formatNumber(budget.display.impressions, 'fixedPoint')}}
											.data-description {{$tCaption('impressions')}}
										.flex-row
											.data-value {{formatNumber(budget.display.sum)}}
											.data-description {{$tCaption('dollars')}}
					tr.details(v-if="product.components.indexOf('geofencing') > -1", :class="{invisible: isInvisible(product.id)}")
						td {{$tCaption('Geofencing component')}}
						template(v-for="budget in budgets.map((f, i) => getProductBudget(i, product.oid)).filter(f => f)")
							td.budget-td
								.flex-row
									dxCheckBox(:value="budget.geofencing.enabled", :width="35", @value-changed="v => budget.geofencing.enabled = v.value")
									template(v-if="budget.geofencing.enabled")
										.flex-col
											span {{$tCaption('CPM')}}
											DxNumberBox.bool.number-edit(:value="budget.geofencing.cpm", @value-changed="(v) => budget.geofencing.cpm = v.value", :format="currencyFormat")
										.flex-col
											.flex-row
												.data-value
													DxNumberBox.number-edit(:value="budget.geofencing.impressions", @value-changed="(v) => budget.geofencing.impressions = v.value", format="fixedPoint")
												.data-description {{$tCaption('impressions')}}
											.flex-row
												.data-value {{formatNumber(budget.geofencing.sum)}}
												.data-description {{$tCaption('dollars')}}
					tr.details(v-if="product.components.indexOf('remarketing') > -1", :class="{invisible: isInvisible(product.id)}")
						td {{$tCaption('Remarketing')}}
						template(v-for="budget in budgets.map((f, i) => getProductBudget(i, product.oid)).filter(f => f)")
							td.budget-td
								.flex-row(v-if="budget.geofencing.enabled")
									dxCheckBox(:value="budget.remarketing.enabled", :width="35", @value-changed="v => budget.remarketing.enabled = v.value && budget.geofencing.enabled")
									.flex-row(v-if="budget.remarketing.enabled")
										.data-value
											DxNumberBox.bool.number-edit(:value="budget.remarketing.upcharge", @value-changed="(v) => budget.remarketing.upcharge = v.value", :format="currencyFormat")
										.data-description {{$tCaption('Remarketing Upcharge')}}
					template(v-if="product.id === 'radio'")
						tr.details(:class="{invisible: isInvisible(product.id)}")
							td {{$tCaption('Radio costs')}}
							template(v-for="budget in budgets.map((f, i) => getProductBudget(i, product.oid)).filter(f => f)")
								td.budget-td
									.flex-row
										.data-value {{formatNumber(data.radioCost)}}
						tr.details(:class="{invisible: isInvisible(product.id)}")
							td {{$tCaption('Radio spots')}}
							template(v-for="budget in budgets.map((f, i) => getProductBudget(i, product.oid)).filter(f => f)")
								td.budget-td
									.flex-row
										.data-value {{data.radioSpots}}
				tr.total-row.clickable(@click="toggleExpandedItem('fees')")
					td
						.product.horizontal-spacing
							.flex-row.justify
								.flex-row.left.space
									.expander(:class="{ expanded: expandedItems.indexOf('fees') > -1 }")
										i.fas.fa-chevron-right
									.icon
										i.fas.fa-dollar-sign
									.name {{$tCaption('Fees')}}
								DxButton(v-if="!isInvisible('fees')", icon="plus", @click="addNewFee")
					template(v-for="budget in budgets")
						td.budget-td
							.budget-total
								.value {{formatNumber(budget.totalRecurringFee)}}
								.description {{getReccurencyPeriod(budget)}}
				template(v-for="(fee, feeIdx) in fees")
					tr.details(:class="{invisible: isInvisible('fees')}")
						td
							.flex-row.flex-justify
								template(v-if="editingFeeIndex === feeIdx")
									.flex-row.space
										DxTextBox(:value="fee.name", @value-changed="(v) => { editingFeeIndex = null; fee.name = v.value }")
										DxCheckBox(:value="fee.recurrent", :text="$tCaption('Recurring')", :width="105", @value-changed="v => fee.recurrent = v.value")
										DxButton(icon="check", @click="editingFeeIndex = null")
								template(v-else)
									.name {{fee.name}}
									.edit.flex-row.space
										DxButton(icon="edit", @click="editingFeeIndex = feeIdx")
										DxButton(icon="trash", @click="fees.splice(feeIdx, 1)")
						template(v-for="item in budgets.map((f, i) => ({ budgetFee: getFeeBudget(i, feeIdx), period: f.period })).filter(f => f.budgetFee)")
							td.budget-td
								.flex-row
									.data-value
										DxNumberBox.bool.number-edit(:value="item.budgetFee.fee", @value-changed="(v) => item.budgetFee.fee = v.value", :format="currencyFormat")
									.data-description {{item.budgetFee.recurrent ? getReccurencyPeriod(item.period) : $tCaption('one time')}}
				tr.total-recurring-row.total-row
					td
						.product.horizontal-spacing
							.icon
								i.fas.fa-calculator
							.name {{$tCaption('Total recurring')}}
					template(v-for="budget in budgets")
							td.budget-td
								.budget-total
									.value {{formatNumber(budget.totalRecurring)}}
									.description {{getReccurencyPeriod(budget)}}
				tr.grand-total-row.total-row
					td
						.product.horizontal-spacing
							.icon
								i.fas.fa-calculator
							.name {{$tCaption('Grand total')}}
					template(v-for="budget in budgets")
							td.budget-td
								.budget-total
									.value {{formatNumber(budget.total)}}
</template>

<script>
	import _ from 'lodash';
	import VueTypes from 'vue-types';
	import { DxNumberBox } from 'devextreme-vue/number-box';
	import DxButton from 'devextreme-vue/button';
	import Localization from 'devextreme/localization.js';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxSelectBox from 'devextreme-vue/select-box';

	export default {
		translationCategory: 'proposal.BudgetSelection',
		name: 'budget-selection',
		components: {
			DxButton,
			DxNumberBox,
			DxCheckBox,
			DxTextBox,
			DxSelectBox
		},
		props: {
			data: VueTypes.object.def({}),
			products: VueTypes.array.def([])
		},
		data() {
			return {
				budgets: this.populateWithDefaults(_.clone(this.$getSetting('proposal.budgets')), { productsBudget: [], fees: [], total: 0, totalRecurring: 0 }) || [
					{ name: () => this.$tCaption('Standard'), total: 0, totalRecurring: 0, period: 'month', term: 12, productsBudget: [], fees: [] },
					{ name: () => this.$tCaption('Super'), total: 0, totalRecurring: 0, period: 'month', term: 12, productsBudget: [], fees: [] }
				],
				budgetIsCalculating: false,
				editingBudgetIndex: null,
				editingFeeIndex: null,
				currencyFormat: '$#0.##',
				fees: _.clone(this.$getSetting('proposal.fees')) || [
					{ name: () => this.$tCaption('Monthly fee 1'), fee: 0, recurrent: true },
					{ name: () => this.$tCaption('Monthly fee 2'), fee: 0, recurrent: true },
					{ name: () => this.$tCaption('Monthly fee 3'), fee: 0, recurrent: true },
					{ name: () => this.$tCaption('One time fee 1'), fee: 0, recurrent: false }
				],
				expandedItems: [],
				periodTypes: [{ id: 'month', name: () => this.$tCaption('month(s)') }, { id: 'week', name: () => this.$tCaption('week(s)') }]
			};
		},
		watch: {
			budgets: {
				handler() {
					this.calculateBudget();
				},
				deep: true
			}
		},
		mounted() {
			this.budgets.map((budget, i) => this.buildProductBudget(budget, i));
			this.calculateBudget();
			if (__DEBUG__)
				console.info('Budgets built', this.budgets);
		},
		methods: {
			populateWithDefaults(arr, def) {
				if (arr)
					arr.map(f => {
						Object.keys(def).map(k => {
							if (f[k] === void 0) {
								f[k] = def[k];
							}
						});
					});
				return arr;
			},
			getCurrencyFormat(budget) {
				return `${this.currencyFormat} ${this.getReccurencyPeriod(budget)}`;
			},
			isInvisible(id) {
				return this.expandedItems.indexOf(id) === -1;
			},
			toggleExpandedItem(id) {
				var idx = this.expandedItems.indexOf(id);
				if (idx > -1)
					this.expandedItems.splice(idx, 1);
				else
					this.expandedItems.push(id);
			},
			addNewBudget() {
				var item = _.cloneDeep(this.budgets[this.budgets.length - 1]);
				item.name += () => ' ' + this.$tCaption('copy');
				this.budgets.push(item);
				this.calculateBudget();
			},
			addNewFee(e) {
				e.event.stopPropagation();
				this.fees.push({ name: () => this.$tCaption('New fee'), fee: 0, recurrent: false });
				this.editingFeeIndex = this.fees.length-1;
			},
			calculateBudget() {
				if (!this.budgetIsCalculating) {
					if (__DEBUG__)
						console.info('CalculateBudget');
					this.budgetIsCalculating = true;
					this.budgets.map(budget => {
						const recurringProducts = budget.productsBudget.filter(f => this.getProduct(f.product).recurrent !== false);
						const notRecurringProducts = budget.productsBudget.filter(f => this.getProduct(f.product).recurrent === false);
						recurringProducts.filter(f => this.getProduct(f.product).recurrent !== false).map(pb => {
							var product = this.getProduct(pb.product);
							var hasGeofencing = product.components.indexOf('geofencing') > -1 && pb.geofencing.enabled;
							var hasRemarketing = product.components.indexOf('remarketing') > -1 && pb.remarketing.enabled && pb.geofencing.enabled;

							pb.remarketing.enabled = hasRemarketing;

							pb.geofencing.totalCpm = this.toFixed((hasRemarketing ? pb.remarketing.upcharge : 0) + pb.geofencing.cpm);
							pb.geofencing.sum = this.toFixed(pb.geofencing.impressions * pb.geofencing.totalCpm / 1000);
							pb.geofencing.enabled = hasGeofencing;

							pb.display.sum = this.toFixed(pb.recurrentBudget - (hasGeofencing ? pb.geofencing.sum : 0));
							pb.display.impressions = this.toFixed(pb.display.sum * 1000 / pb.display.cpm);
						});

						budget.totalRecurringProducts = _.sumBy(recurringProducts, f => f.recurrentBudget);
						budget.totalRecurringFee = _.sumBy(budget.fees.filter(f => f.recurrent), f => f.fee);

						budget.totalRecurring = budget.totalRecurringProducts + budget.totalRecurringFee;
						budget.total = (budget.totalRecurring * budget.term || 0)
							+ (_.sumBy(notRecurringProducts, f => f.recurrentBudget) || 0)
							+ (_.sumBy(budget.fees.filter(f => f.recurrent === false), f => f.fee) || 0);

						if (__DEBUG__)
							console.info('Budgets calculated', this.budgets);
					});
					setImmediate(() => {
						if (this._isDestroyed) return;
						this.budgetIsCalculating = false;
						this.data.budget = this.budgets;
					});
				}
			},
			toFixed(num) {
				if (isNaN(num)) return 0;
				return Number(parseFloat(num).toFixed(2));
			},
			buildProductBudget(budget, bIdx) {
				this.data.products.map(p => {
					budget.productsBudget.push({
						product: p,
						recurrentBudget: p === 'radio' ? this.data.radioCost : (bIdx + 2) * 1000,
						display: {
							cpm: 12,
							impressions: 168800,
							sum: 1300
						},
						geofencing: {
							enabled: true,
							cpm: 12,
							impressions: 50000,
							sum: 700,
							totalCpm: 12
						},
						remarketing: {
							enabled: true,
							upcharge: 2
						}
					});
					budget.fees = _.cloneDeep(this.fees);
				});
			},
			getProduct(oid) {
				return _.find(this.products, {oid});
			},
			getProductBudget(budgetId, product) {
				return _.find(this.budgets[budgetId].productsBudget, { product });
			},
			getFeeBudget(budgetId, feeIdx) {
				return this.budgets[budgetId] && this.budgets[budgetId].fees && this.budgets[budgetId].fees[feeIdx];
			},
			formatNumber(num, type) {
				return Localization.formatNumber(num, {
					type: type || 'currency',
					precision: 0
				});
			},
			getReccurencyPeriod(budget) {
				if (budget) {
					switch(budget.period) {
						case 'month':
							return 'monthly';
						case 'week':
							return 'weekly';
					}
				}
				return '';
			}
		}
	};
</script>
<style lang='scss'>
	.budget-selection {
		@import "main/themes/generated/variables.base.scss";

		.clickable {
			cursor: pointer;
		}
		.invisible {
			visibility: collapse;
			opacity: 0 !important;
		}
		.flex-row {
			display: flex;
			flex-direction: row;
			align-items: center;

			> *:not(:first-child) {
				margin-left: 6px;
			}
		}

		.flex-justify {
			flex: 1;
			justify-content: space-between;
		}

		.no-wrap {
			white-space: nowrap;
			flex-wrap: nowrap;
		}

		.horizontal-spacing {
			> * {
				&:not(:first-child) {
					margin-left: 6px;
				}
			}
		}

		.flex-wrap {
			flex-wrap: wrap;
		}

		.flex-col {
			display: flex;
			flex-direction: column;
			justify-content: center;
		}

		.data-value {
			font-size: 16px;
			color: rgba(0,0,0,0.3);
		}

		.data-description {
			color: rgba(0,0,0,0.3);
		}

		.product {
			display: flex;
			flex-direction: row;
			align-items: center;
			font-size: 16px;

			.expander {
				transition: 0.3s;

				&.expanded {
					transform: rotate(90deg);
				}
			}
		}

		.number-edit {
			width: 115px;

			&.bool {
				width: 75px;
			}
		}

		.budget-table {
			td {
				padding: 20px;
			}

			.details {
				td {
					padding: 10px 20px 10px 20px;
				}
			}

			.budget-td:nth-child(even) {
				background-color: #e8e8e8;
			}

			.budget-td:nth-child(odd) {
				background-color: #dedede;
			}

			.total-row {
				background: $base-accent;
				color: #fff;

				> td {
					border-bottom: 1px solid rgba(0,0,0,0.1);
				}

				.budget-td {
					&:nth-child(even) {
						background: $base-accent;
					}

					&:nth-child(odd) {
						background: $base-accent-hover;
					}
				}

				.budget-total {
					display: flex;
					align-items: baseline;

					.value {
						font-size: 22px;
					}

					.description {
						font-size: 12px;
						margin-left: 6px;
					}
				}
			}

			.grand-total-row {
				td:last-child {
					border-bottom-right-radius: 8px;
				}
			}

			.details {
				opacity: 1;

				&:not(.invisible) {
					transition: 0.4s;
				}

				td:first-child {
					padding-left: 46px;
				}

				.highlight {
					color: #53c5b0;
					font-size: 15px;
					font-weight: 600;
				}

				> td {
					border-color: #3333330a;
					border-bottom-width: 1px;
					border-bottom-style: solid;
				}
			}

			.header-row {
				font-size: 20px;
				font-weight: 100;

				.budget-td:nth-child(2) {
					border-top-left-radius: 8px;
				}

				.budget-td:last-child {
					border-top-right-radius: 8px;
				}
			}
		}

		.center-aligned-number-box .dx-texteditor-input {
			text-align: center;
		}
	}
</style>
